<p-fieldset legend="Autorização Secretaria da Fazenda e Planejamento">
  <div class="row">
    <label class="required col-12 col-form-label">
      Há nos autos autorização da Secretaria Estadual da Fazenda e Planejamento e da Secretaria Estadual de Governo, nos
      termos do Decreto Estadual nº 64.070 de 02/01/2019?
    </label>
    <p-selectButton [options]="opcoesSimNaoNA" optionValue="id" class="col-12"
      [(ngModel)]="entidade.Autorizacao.ExisteAutorizacaoSecretEstadualDL4116596" [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
</p-fieldset>
<p-fieldset legend="Declaração de disponibilidade de documentos">
  <div class="row">
    <label class="required col-12 col-form-label">
      Declaração nos termos do art. 83, XVIII, da instrução 02/2016
    </label>
    <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-12"
      [(ngModel)]="entidade.Autorizacao.ExisteAutorizacaoResolucao7_2014" [ngModelOptions]="{standalone: true}">
      <ng-template let-opcao>
        <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
      </ng-template>
    </p-selectButton>
  </div>
</p-fieldset>
<p-fieldset legend="Situação da Licitação"
  *ngIf="registroPreco === 'N' && entidade.modalidade !== 10 && entidade.modalidade !== 11">
  <div class="row">
    <label class="required col-3">
      Situação do Procedimento Licitatório
    </label>
    <select [compareWith]="compareFn" class="form-control col-3" [(ngModel)]="entidade.SituacaoLicitacao"
      [ngModelOptions]="{standalone: true}">
      <option *ngFor="let item of opcoesSituacaoLicitacao" [ngValue]="item.id">{{item.nome}}</option>
    </select>
    <label class="required col-2 col-form-label">
      Data
    </label>
    <p-calendar (onFocus)="onFocusDate()"[(ngModel)]="entidade.DtSituacaoLicitacao" [ngModelOptions]="{standalone: true}"
      inputStyleClass="form-control col-auto" dataType="string" dateFormat="dd/mm/yy" [showOnFocus]="true"
      [showButtonBar]="true" [showIcon]="true">
    </p-calendar>
  </div>
  <div class="row" *ngIf="entidade.SituacaoLicitacao === 5">
    <label class="required col-3 col-form-label">
      Descrição da Situação
    </label>
    <input type="text" class="form-control col-8" [(ngModel)]="entidade.DescricaoSituacaoLicitacao"
      [ngModelOptions]="{standalone: true}">
  </div>
</p-fieldset>